export interface PresignedUploadRequest {
  file: File;
  method: string;
  onProgress?: (percent: number) => void;
  requiredHeaders: Readonly<Record<string, string>>;
  url: string;
}

export function uploadPresignedFile({
  file,
  method,
  onProgress,
  requiredHeaders,
  url,
}: PresignedUploadRequest): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new window.XMLHttpRequest();

    xhr.open(method, url, true);
    Object.entries(requiredHeaders).forEach(([name, value]) => {
      xhr.setRequestHeader(name, value);
    });

    xhr.upload.addEventListener("progress", (event) => {
      if (!event.lengthComputable || event.total <= 0) {
        return;
      }
      onProgress?.(Math.round((event.loaded / event.total) * 100));
    });

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress?.(100);
        resolve();
        return;
      }
      reject(new Error("WAV upload failed."));
    });

    xhr.addEventListener("error", () => {
      reject(new Error("WAV upload failed."));
    });

    xhr.addEventListener("abort", () => {
      reject(new Error("WAV upload was canceled."));
    });

    // Clear the Blob content type so the browser only sends returned headers.
    xhr.send(file.slice(0, file.size, ""));
  });
}
